export const ADD_POPOVER_NOTIFICATION_MESSAGE =
  'ADD_POPOVER_NOTIFICATION_MESSAGE'
export const SET_BRAND = 'SET_BRAND'
export const RESET_MAYA_STATE = `RESET_MAYA_STATE`
export const UPDATE_EXISTING_MESSAGE = `UPDATE_EXISTING_MESSAGE`
export const SET_USER_HAS_SENT_MESSAGE = `SET_USER_HAS_SENT_MESSAGE`
export const SET_LAST_ACTIVE_TIME = `SET_LAST_ACTIVE_TIME`
export const SET_SHOW_FEEDBACK_MODAL = `SET_SHOW_FEEDBACK_MODAL`
export const SET_ORGANIZATION_DETAILS_ERROR = `SET_ORGANIZATION_DETAILS_ERROR`
export const IS_PLAN_REQUESTED = `IS_PLAN_REQUESTED`
export const IS_CHAT_READY = `IS_CHAT_READY`
export const ANIMATE_DEFAULT_MESSAGES = `ANIMATE_DEFAULT_MESSAGES`
export const SET_REGENERATE_RESPONSE = 'SET_REGENERATE_RESPONSE'
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE'
export const REMOVE_EXISTING_MESSAGE = 'REMOVE_EXISTING_MESSAGE'
export const SET_FETCH_INTENT_STATE = 'SET_FETCH_INTENT_STATE'
export const SET_INTENT_GRID = 'SET_INTENT_GRID'
export const SET_IS_GRID_MODE = 'SET_IS_GRID_MODE'
export const ADD_MAYA_RESPONSE = 'ADD_MAYA_RESPONSE'
export const SET_MAYA_CHAT_RESPONSE = 'SET_MAYA_CHAT_RESPONSE'
export const IS_MAYA_RESPONDING = 'IS_MAYA_RESPONDING'
export const SET_SOCKET_CONNECTION_ESTABLISHED =
  'SET_SOCKET_CONNECTION_ESTABLISHED'
export const IS_EXPECTING_ASSISTANT_RESPONSE = 'IS_EXPECTING_ASSISTANT_RESPONSE'
export const SET_IS_TEST_CASE = 'SET_IS_TEST_CASE'
export const DEFAULT_SEARCH_RESULTS = 'DEFAULT_SEARCH_RESULTS'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_IS_FETCHING_SEARCH_RESULTS = 'SET_IS_FETCHING_SEARCH_RESULTS'
export const SET_MAYA_AI_QUERY_RESPONSE = 'SET_MAYA_AI_QUERY_RESPONSE'
export const SET_IS_FETCHING_AI_QUERY_RESPONSE =
  'SET_IS_FETCHING_AI_QUERY_RESPONSE'
export const SET_MAYA_AI_QUERY_TOKEN = 'SET_MAYA_AI_QUERY_TOKEN'
export const SET_IS_INTERNAL_CASE = 'SET_IS_INTERNAL_CASE'
export const SET_IS_INTERNAL_CASE_IN_QUERY_OR_OPTIONS =
  'SET_IS_INTERNAL_CASE_IN_QUERY_OR_OPTIONS'
export const SET_GENERATE_AI_QUERY_RESPONSE = 'SET_GENERATE_AI_QUERY_RESPONSE'
export const UPDATE_ASSISTANT_RESPONSE_ID = 'UPDATE_ASSISTANT_RESPONSE_ID'

export const FETCH_ORGANIZATION_DETAILS = 'FETCH_ORGANIZATION_DETAILS'
export const FETCH_ORGANIZATION_DETAILS_PENDING =
  'FETCH_ORGANIZATION_DETAILS_PENDING'
export const FETCH_ORGANIZATION_DETAILS_FULFILLED =
  'FETCH_ORGANIZATION_DETAILS_FULFILLED'
export const FETCH_ORGANIZATION_DETAILS_REJECTED =
  'FETCH_ORGANIZATION_DETAILS_REJECTED'

export const FETCH_CHAT = 'FETCH_CHAT'
export const FETCH_CHAT_PENDING = 'FETCH_CHAT_PENDING'
export const FETCH_CHAT_REJECTED = 'FETCH_CHAT_REJECTED'
export const FETCH_CHAT_FULFILLED = 'FETCH_CHAT_FULFILLED'

export const REQUEST_PLAN_PENDING = 'REQUEST_PLAN_PENDING'
export const REQUEST_PLAN_REJECTED = 'REQUEST_PLAN_REJECTED'
export const REQUEST_PLAN_FULFILLED = 'REQUEST_PLAN_FULFILLED'

export const FETCH_DEFAULT_CHAT = 'FETCH_DEFAULT_CHAT'
export const FETCH_DEFAULT_CHAT_PENDING = 'FETCH_DEFAULT_CHAT_PENDING'
export const FETCH_DEFAULT_CHAT_FULFILLED = 'FETCH_DEFAULT_CHAT_FULFILLED'
export const FETCH_DEFAULT_CHAT_REJECTED = 'FETCH_ORGANIZATION_DETAILS_REJECTED'

export const GET_DEFAULT_TRIPS = 'GET_DEFAULT_TRIPS'
export const GET_DEFAULT_TRIPS_PENDING = 'GET_DEFAULT_TRIPS_PENDING'
export const GET_DEFAULT_TRIPS_REJECTED = 'GET_DEFAULT_TRIPS_REJECTED'
export const GET_DEFAULT_TRIPS_FULFILLED = 'GET_DEFAULT_TRIPS_FULFILLED'

export const FETCH_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS'
export const FETCH_SEARCH_RESULTS_PENDING = 'FETCH_SEARCH_RESULTS_PENDING'
export const FETCH_SEARCH_RESULTS_REJECTED = 'FETCH_SEARCH_RESULTS_REJECTED'
export const FETCH_SEARCH_RESULTS_FULFILLED = 'FETCH_SEARCH_RESULTS_FULFILLED'

export const SEND_FEEDBACK = 'SEND_FEEDBACK'
export const SEND_FEEDBACK_PENDING = 'SEND_FEEDBACK_PENDING'
export const SEND_FEEDBACK_REJECTED = 'SEND_FEEDBACK_REJECTED'
export const SEND_FEEDBACK_FULFILLED = 'SEND_FEEDBACK_FULFILLED'
